import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Article from '../../components/article/article';
import Filters from '../../components/filters/filters';
import SmallTv, { TvColor } from '../../components/small-tv/small-tv';
import { useCourses } from '../../hooks/use-courses';
import useWindowDimensions from '../../hooks/use-window-dimensions';
import './courses-teaching.scss';
import FavouritesService from '../../services/FavouritesService';
import { useQueryClient } from "react-query";

function CoursesTeaching() {
  const { isLoading, data } = useCourses('');
  const [chunkSize, setChunkSize] = useState(2);
  const [rowData, setRowData] = useState<any[]>([]);

  const { width, height } = useWindowDimensions();
  const queryClient = useQueryClient()

  const toggleFavourites = async (courseId: string) => {
    try {
      if (!courseId) return;
      await FavouritesService.toggleFavourites(courseId);
      queryClient.invalidateQueries('courses')
    } catch (error) {
      console.log("Error changing favourites", error)
    }
  }
  useEffect(() => {
    setChunkSize(width < 768 ? 1 : (width < 1200 ? 2 : 3));
  }, [width])

  useEffect(() => {
    if (data && data.data) {
      const newData: any[] = [];
      for (let i = 0; i < data.data.length; i += chunkSize) {
        const chunk = data.data.slice(i, i + chunkSize);
        newData.push(chunk);
      }
      setRowData(newData);
    }

  }, [chunkSize, data])

  const getRandomBoolean = () => {
    const rndInt = Math.floor(Math.random() * 6)
    return rndInt % 2 === 0;
  }

  if (isLoading) {
    return (<div>
      Loading...
    </div>)
  } else {
    return (
      <div className="courses">
        <div className='courses__content'>
          {
            rowData && rowData.map((row: any[], index: number) => {
              return <div className='shelf-wrapper' key={index}>
                <div className='shelf-wrapper__content'> {
                  row.map((course: any) => {
                    return (
                      <div key={course.id}>
                        {
                          course.type === 'video' &&
                          <SmallTv
                            id={course.id}
                            title={course.title}
                            picture={course.picture}
                            price={course.price}
                            rating={course.rating}
                            studentNr={course.studentNr}
                            favourite={course.favourite}
                            toggleFavourites={toggleFavourites}
                            hasSideButtons={getRandomBoolean()}
                            hasBottomButton={getRandomBoolean()}
                            onClickBasePath='/teaching/edit-course'
                            color={getRandomBoolean() ? TvColor.BROWN : TvColor.GREY}

                          />}

                        {
                          course.type === 'article' &&
                          <Article title={course.title}
                            picture={course.picture}
                            price={course.price}
                            hasSideButtons={getRandomBoolean()}
                            hasBottomButton={getRandomBoolean()}
                            color={getRandomBoolean() ? TvColor.BROWN : TvColor.GREY} />
                        }
                      </div>
                    )
                  })}
                </div>
                <div className='shelf'>
                  <div className='shelf__wood'>
                  </div>
                  <div className='shelf__wood-front'>
                  </div>
                </div>
              </div>

            })
          }

        </div>
      </div>
    );
  }
}

export default CoursesTeaching;
